<div class="w-full h-full" #mainDiv>
  <div id="topoMap"></div>
  <div class="map-overlay" *ngIf="mapIsLoading" [@fadeInOut]>
    <div class="flex justify-content-center align-items-center h-full">
      <div class="lds-dual-ring"></div>
    </div>
  </div>
</div>

<div class="hidden">
  <div class="mapboxgl-ctrl mapboxgl-ctrl-group" id="map-layer-control-filters">
    <button
      [style.backgroundColor]="'white'"
      [style.color]="'black'"
      (click)="filtersVisible=true;"
      pRipple
      class="hover:bg-black-alpha-10"
      type="button"
    >
      <i class="pi pi-filter" style="font-size: 16px;"></i>
    </button>
  </div>
</div>

<div class="hidden">
  <div id="map-legend" class="legend">
    <div><b>{{ 'nettopo.legend' | transloco }}</b></div>
    <div><span>- - - {{ 'nettopo.throughGW' | transloco }}</span></div>
    <div><span>----- {{ 'nettopo.throughHUB' | transloco }}</span></div>
    <div><span class="dot" style="background-color: #03c211 !important;"></span>GW</div>
    <div><span class="dot" style="background-color: #acb900 !important;"></span>HUB</div>
    <div><span class="dot" style="background-color: #4264fb !important;"></span>DEVICE</div>
    <div><span class="dot" style="background-color: #42bafb !important;"></span>IMPORTED DEVICE</div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{ 'common.filters' | transloco }}</h2>
  <div>
    <div class="col-12" *ngIf="authGuardService.superAdminRequired() && tenants">
      <div class="col-12 form-field">
        <label for="tenant">{{ 'model.tenant' | transloco }}</label>
      </div>
      <div class="col-12">
        <p-multiSelect
          [(ngModel)]="currentFilters.tenantUuids"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body"
          [options]="tenants"
          id="tenant"
          optionLabel="name"
          optionValue="uuid"
        ></p-multiSelect>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="codes">{{ 'nettopo.integrationCodes' | transloco }}</label>
      </div>
      <div class="col-12">
        <p-chips
          styleClass="w-full block"
          [(ngModel)]="currentFilters.codes"
          id="codes"
        ></p-chips>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="dateRanges">{{ 'nettopo.dateRange' | transloco }}</label>
      </div>
      <div class="col-12">
        <p-calendar
          [(ngModel)]="currentFilters.rangeDates"
          [firstDayOfWeek]="1"
          [readonlyInput]="false"
          styleClass="w-full"
          id="dateRanges"
          selectionMode="range"
          [showTime]="true"
          appendTo="body"
        ></p-calendar>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="visibleLayer">{{ 'nettopo.coverageLevel' | transloco }}</label>
      </div>
      <div class="col-12" [formGroup]="layerForm">
        <p-dropdown
          formControlName="visibleLayer"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body"
          [options]="coverageLevels"
          [showClear]="layerForm.get('visibleLayer').value !== CoverageLevel.ANY"
          (onClear)="resetActiveLayer()"
          id="visibleLayer"
        >
          <ng-template pTemplate="selectedItem" let-item>
            {{ ('nettopo.coverageLevels.' + item) | transloco }}
          </ng-template>
          <ng-template pTemplate="item" let-item>
            {{ ('nettopo.coverageLevels.' + item) | transloco }}
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        (onClick)="filtersVisible = false; loadMapData()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>

<app-node-details
  [nodes]="nodes"
  [selectedIntegrationCode]="selectedIntegrationCode"
  [selectedDeviceUuid]="selectedDeviceUuid"
  [selectedDeviceSerialNumber]="selectedDeviceSerialNumber"
  [loadingNodes]="mapIsLoading"
  [(visible)]="showNodeDialog"
></app-node-details>
